module.exports = __webpack_public_path__ + "static/media/actions-applied-outline.2cda427b.svg";